// ============================================================
// fondos/efectos/aurora.js — «Aurora»: cintas de luz que ondulan y se cruzan (efecto de CAPAS, PURO)
//
// P3 del motor de fondos, F3 (§3 del plan: E4, E5, E10, V5). Antes: un lienzo a ⅓ con 3 bandas de
// 25 círculos sumados en `lighter` —se comía el 22,6 % del hilo principal— cuyo segundo color, en
// una sección clara, salía casi negro (`--secondary` contrastado: la «banda pizarra», E4).
//
// Rehecha el 29-09 (§3.1 del traspaso: la primera versión de capas eran 3 elipses a vaivén de 16-24 s
// y el dueño la vio muerta, «se ven casi todos igual»). Ahora cada CINTA es:
//   · una envoltura más ancha que la sección que se MECE a su ritmo: sube y baja, se desplaza y gira
//     unos grados, así que las cintas se acercan y se cruzan;
//   · dentro, unos TRAMOS elípticos solapados que recorren la misma ONDA (`manchas.js::onda`) con el
//     retraso escalonado: la ondulación viaja a lo largo de la cinta y cada tramo se inclina con la
//     pendiente y brilla en la cresta. Las cintas vecinas ondulan en sentidos opuestos;
//   · colores alternos: el acento y el segundo color de la marca (`fondos/paleta.js`);
//   · núcleo acotado por el alfa máximo de la polaridad (catálogo), algo por debajo porque los tramos
//     se solapan.
// ============================================================

import { duracion, medida, perfil, crecePorSuavidad, entre, onda, AREA_MAX } from './manchas.js';

/** Envoltura de una cinta (cqmax): más ancha que la sección, para que no se le vean los extremos. */
const CINTA_ANCHO = 116;
const CINTA_ALTO = 50;
/** Un tramo de la cinta (cqmax, elipse) y cuánto de la onda hay entre dos tramos vecinos. */
const TRAMO_ANCHO = 58;
const TRAMO_ALTO = 16;
const DESFASE = 0.2;
/** Filas de las cintas (% del alto). */
const FILAS = [27, 50, 73];
const FILAS_TACTIL = [36, 64];

export default {
    disenar(e) {
        const p = e.params || {};
        const filas = e.tactil ? FILAS_TACTIL : FILAS;
        const tramos = e.tactil ? 3 : 4;
        const crece = crecePorSuavidad(p.blur);
        // Tope en px de cada tramo con su proporción, para que todos sumen AREA_MAX.
        const altoMax = Math.floor(Math.sqrt(AREA_MAX / (filas.length * tramos) / (TRAMO_ANCHO / TRAMO_ALTO)));
        const anchoMax = Math.floor(altoMax * TRAMO_ANCHO / TRAMO_ALTO);
        const alfa = e.alfa * 0.8;
        const manchas = [];
        filas.forEach(function (fila, b) {
            const color = b % 2 === 0 ? e.c1 : e.c2;
            const sentido = b % 2 === 0 ? 1 : -1;
            const periodo = duracion(entre(e.azar, 6000, 8500), p.speed);
            const fase = entre(e.azar, 0, 1);
            const ay = entre(e.azar, 9, 12);
            const hijos = [];
            for (let j = 0; j < tramos; j++) {
                // El escalonado va con el sentido de la cinta: la onda viaja a un lado o al otro.
                const k = sentido > 0 ? j : tramos - 1 - j;
                hijos.push({
                    caja: {
                        ancho: medida(Math.round(TRAMO_ANCHO * crece), anchoMax),
                        alto: medida(Math.round(TRAMO_ALTO * crece), altoMax),
                        x: Math.round((j + 0.5) * 100 / tramos),
                        y: 50,
                    },
                    forma: 'ellipse',
                    color: color,
                    perfil: perfil(alfa, p.blur, 1.9),
                    fotogramas: onda(12, ay, 3, sentido * 13, 0.55),
                    duracion: periodo,
                    retraso: -Math.round(((fase + k * DESFASE) % 1) * periodo),
                    direccion: 'normal',
                    curva: 'linear',
                });
            }
            const mecida = duracion(entre(e.azar, 9000, 13000), p.speed);
            const f = [];
            for (let i = 0; i < 3; i++) {
                const lado = i % 2 === 0 ? -1 : 1;
                f.push({ transform: 'translate(' + entre(e.azar, -7, 7) + 'cqw, ' + Math.round(lado * sentido * entre(e.azar, 8, 13) * 100) / 100
                    + 'cqh) rotate(' + Math.round(lado * sentido * entre(e.azar, 4, 8) * 100) / 100 + 'deg)' });
            }
            manchas.push({
                caja: {
                    ancho: medida(CINTA_ANCHO, 4000),
                    alto: medida(CINTA_ALTO, 2000),
                    x: Math.round(50 + entre(e.azar, -4, 4)),
                    y: fila,
                },
                fotogramas: f,
                duracion: mecida,
                retraso: -Math.round(entre(e.azar, 0, 1) * mecida),
                direccion: 'alternate',
                curva: 'ease-in-out',
                hijos: hijos,
            });
        });
        return { manchas: manchas };
    },
};
